import { PdBaseUI } from "../base/pd-base-ui.js";
import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import "../pd-button-group.js";
import "../pd-panel-button.js";
import { css, html, nothing } from "lit";
import { property, query, state } from "lit/decorators.js";
//#region src/pd-button-select-group/PdButtonSelectGroup.ts
/**
* Dropdown button selector combining pd-panel-button with pd-button-group.
*
* @tagname pd-button-select-group
*
* @event pd-button-selection-changed - Fired when selection changes with `{selected}` detail.
*
* @cssprop --pd-panel-padding - Panel content padding. Default: `0px`.
*/
var PdButtonSelectGroup = class extends PdBaseUI {
	constructor(..._args) {
		super(..._args);
		this.options = [];
		this.initValue = -1;
		this.groupLabel = "";
		this._selectedValue = -1;
	}
	static {
		this.styles = [PdBaseUI.styles, css`
      :host {
        display: inline-block;
        position: relative;
        --pd-panel-padding: 0px;
      }
    `];
	}
	willUpdate(changedProps) {
		if (changedProps.has("initValue") && this.initValue >= 0) this._selectedValue = this.initValue;
	}
	reset(selectedValue) {
		this._selectedValue = selectedValue;
		if (this._buttonGroupEl) this._buttonGroupEl.reset(selectedValue);
	}
	render() {
		if (!this.options || this.options.length === 0) return nothing;
		const selectedData = this.options[this._selectedValue === -1 ? 0 : this._selectedValue];
		const isIconOnly = !selectedData?.text && !!selectedData?.pdIcon;
		return html`
      <pd-panel-button
        hide-close
        ?icon-only="${isIconOnly}"
        .text="${selectedData?.text ?? ""}"
        .icon="${selectedData?.pdIcon ?? ""}"
      >
        <pd-button-group
          id="buttonGroupId"
          vertical
          .buttonList="${this.options}"
          .initValue="${[this._selectedValue]}"
          .groupLabel="${this.groupLabel}"
          @pd-button-group-change="${this.handleSelectionChange}"
        ></pd-button-group>
      </pd-panel-button>
    `;
	}
	handleSelectionChange(e) {
		e.stopPropagation();
		const [newIndex] = e.detail.selected;
		this._selectedValue = newIndex;
		window.dispatchEvent(new Event("close-button-panel-event"));
		this._panelButtonEl?.focus();
		this.dispatchEvent(new CustomEvent("pd-button-selection-changed", {
			detail: { selected: newIndex },
			bubbles: true,
			composed: true
		}));
	}
};
__decorate([property({ type: Array })], PdButtonSelectGroup.prototype, "options", void 0);
__decorate([property({ type: Number })], PdButtonSelectGroup.prototype, "initValue", void 0);
__decorate([property({
	type: String,
	attribute: "group-label"
})], PdButtonSelectGroup.prototype, "groupLabel", void 0);
__decorate([state()], PdButtonSelectGroup.prototype, "_selectedValue", void 0);
__decorate([query("#buttonGroupId")], PdButtonSelectGroup.prototype, "_buttonGroupEl", void 0);
__decorate([query("pd-panel-button")], PdButtonSelectGroup.prototype, "_panelButtonEl", void 0);
//#endregion
export { PdButtonSelectGroup };
